import React, { Component } from "react";
import { connect } from "react-redux";
import { 
  fetchDropdownList,
  fetchAppointmentDetails,
  fetchCalendarAppointments,
  fetchAppointmentDropdown } from "../../redux";
import ttmLoader from "../../assets/images/ttm-loader.gif";
import BigCustomCalender from "../../containers/BigCustomCalender";
import moment from 'moment';
import style from "./AppointmentsCalendar.module.css";
import {Modal, ModalHeader, ModalBody } from "reactstrap";
import { firstLetterCapital } from "../../utils/CommonUtil";
import Api from "../../utils/Api";
import { checkIfPermitted, Permissions } from "../../services/RolePermissionService";

function dateFormatter(cell) {
  if (!cell) {
    return "";
  }
  return `${
    moment(cell).format("YYYY-MM-DD")
      ? moment(cell).format("YYYY-MM-DD")
      : moment(cell).format("YYYY-MM-DD")
  }`;
}

export class AppointmentsCalendar extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isScreenLoaded: false,
      isModalOpenAppointment: false,
      isAppointmentModalLoading: false,
      isCaseFileDownloading: false,
      successMessage: "",
      errorMessage: ""
    };
  }

  componentDidMount = async()=> {
    document.title = 'Appointment Calendar - TechToMedix';
    this.props.fetchAppointmentDropdown();
    await this.props.fetchCalendarAppointments();

    setTimeout(() => {
      this.setState({
        isScreenLoaded: true,
      });
    }, 2000);
  }

  handleOnNavigate = async(date) => {
    // let currentMonth = new Date().getMonth();
    // let dateMonth = new Date(date).getMonth();
    // console.log("dateMonth", dateMonth);
    // console.log("currentMonth", currentMonth);
    // if(currentMonth != dateMonth){
      await this.props.fetchCalendarAppointments(dateFormatter(date));
   // }
  }

  onEventSelect = (data) => {
   // console.log("data", data)
    this.setState((prevState) => ({
      isModalOpenAppointment: !prevState.isModalOpenAppointment,
      isAppointmentModalLoading: true
    }),async()=>{
      if(this.state.isModalOpenAppointment){
        await this.props.fetchAppointmentDetails(data.appointment_id);
        this.setState({
          isAppointmentModalLoading: false
        })
      }
    });
  }

  downloadFile = async (appointment_id, lk_document_type_id) => {
    let notesType =
      lk_document_type_id === 1
        ? "Doctor Note"
        : lk_document_type_id === 2
        ? "Referral Note"
        : "Prescription";
    this.setState({
      isCaseFileDownloading: true,
    });
    // headers
    const headers = {
      Authorization:
        "Bearer " + JSON.parse(localStorage.getItem("USER_INFO")).token,
      Accept: "application/pdf",
    };

    const payload = {
      appointment_id: appointment_id,
      lk_document_type_id: lk_document_type_id,
    };

    try {
      const response = await Api.post("appointment/notes/download", payload, {
        headers: headers,
        responseType: "blob",
      });

      if (response.status === 200) {
        this.setState({
          isCaseFileDownloading: false,
          successMessage: "Attached document download successfully",
        });

        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `${notesType}.pdf`);
        document.body.appendChild(link);
        link.click();

        setTimeout(() => {
          this.setState({
            successMessage: "",
          });
        }, 2000);
      }
    } catch (error) {
      console.log("Error in download", error);
      this.setState({
        isCaseFileDownloading: false,
        errorMessage: "Error in download",
      });
      setTimeout(() => {
        this.setState({
          errorMessage: "",
        });
      }, 2000);
    }
  };
  
  // Download patient file
  onDownloadSubmitFile = async (appoinmentDetailsData) => {
    this.setState({
      isCaseFileDownloading: true,
    });

    // headers
    const headers = {
      Authorization:
        "Bearer " + JSON.parse(localStorage.getItem("USER_INFO")).token,
      Accept: "application/pdf",
    };

    const payload = {
      patient_id:appoinmentDetailsData.associated_related_party_id,
    };

    try {
      const response = await Api.post(
        "appointment/patientfile/download",
        payload,
        {
          headers: headers,
          responseType: "blob",
        }
      );

      if (response.status === 200) {
        this.setState({
          isCaseFileDownloading: false,
          successMessage: "Patient file download successfully",
        });

        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        if(appoinmentDetailsData && appoinmentDetailsData.file_number){
          link.setAttribute("download", `${appoinmentDetailsData.file_number}.pdf`);
        }else{
        link.setAttribute("download", `${appoinmentDetailsData.name}.pdf`);
        }
        document.body.appendChild(link);
        link.click();

        setTimeout(() => {
          this.setState({
            successMessage: "",
          });
        }, 2000);
      }
    } catch (error) {
      console.log("Error in download", error);
      this.setState({
        isCaseFileDownloading: false,
        errorMessage: "Error in download",
      });
      setTimeout(() => {
        this.setState({
          errorMessage: "",
        });
      }, 2000);
    }
  };

  
  renderScheduledTime = (dateValue, timeValue) => {
    const datetime = new Date(dateValue);
    datetime.setHours(timeValue.split(":")[0]);
    datetime.setMinutes(datetime.getMinutes() + timeValue.split(":")[1]);
    return datetime.toLocaleTimeString();
  }

  renderScheduledDates = (appointment_date) => {
    let selectedDates = JSON.parse(appointment_date);
    if (selectedDates && selectedDates.length > 0) {
      return (
        <div className="">
          {selectedDates.map((date, index) => (
            <div key={index} className={style.inlineDateTimeInnerWrapper}>
              <span key={index} className={style.dateInfo}>
                {/* {date.toLocaleDateString()} {" - "} {date.toLocaleTimeString()} */}
                {/* {new Date(date.bdate).toLocaleDateString()}{" "} */}
                {moment(date.bdate).format("YYYY-MM-DD")}{" "}
                {this.renderScheduledTime(date.bdate, date.start)} {" - "}
                {this.renderScheduledTime(date.bdate, date.end)}
              </span>
            </div>
          ))}
        </div>
      );
    }else{
      return "";
    }
  }

  
  getRoom = (room_id) => {
    const appointmentDropdownData =  this.props.appointmentDropdownData.appointmentDropdown;
 
    if(appointmentDropdownData && appointmentDropdownData.room.length > 0){
     let room = appointmentDropdownData.room.find((item)=>item.room_id === parseInt(room_id) )
     return (room && room.room_name) ? firstLetterCapital(room.room_name): "Not Available";
    }
    return "Not Available";
   }
   

  getRequestedProfessional = (requested_related_party_id) => {
    const appointmentDropdownData =  this.props.appointmentDropdownData.appointmentDropdown;
 
    if(appointmentDropdownData && appointmentDropdownData.requestedProfessional.length > 0){
     let reqProf = appointmentDropdownData.requestedProfessional.find((item)=>item.related_party_id === parseInt(requested_related_party_id) )
     return (reqProf && reqProf.name) ? reqProf.name: "Not Available";
    }
    return "Not Available";
   }

   
  getAppointmentReason = (lk_appointment_reason_id) => {
    const appointmentDropdownData =  this.props.appointmentDropdownData.appointmentDropdown;
 
    if(appointmentDropdownData && appointmentDropdownData.appointmentReason.length > 0){
     let obj = appointmentDropdownData.appointmentReason.find((item)=>item.lk_appointment_reason_id === parseInt(lk_appointment_reason_id) )
     return (obj && obj.appointment_reason) ? obj.appointment_reason: "Not Available";
    }
    return "Not Available";
   }

   getAppointmentStatus = (lk_appointment_status_id) => {
    const appointmentDropdownData =  this.props.appointmentDropdownData.appointmentDropdown;
 
    if(appointmentDropdownData && appointmentDropdownData.appointmentStatus.length > 0){
     let obj = appointmentDropdownData.appointmentStatus.find((item)=>item.lk_appointment_status_id === parseInt(lk_appointment_status_id) )
     return (obj && obj.appointment_status) ? obj.appointment_status: "Not Available";
    }
    return "Not Available";
   }



  render() {

   // console.log("calendarAppointments",this.props.calendarAppointmentsData)

    const calendarData = this.props.calendarAppointmentsData.calendarAppointments;
    let calendarFormattedData = [];
    calendarData && calendarData.forEach(element => {
      let date = moment(element.bdate).format("YYYY-MM-DD");
      let start = moment(date+ " "+ element.start);
      let end = moment(date+ " "+ element.end);
        calendarFormattedData.push({
          'title': `${element.patient_name} (Dr. ${element.practitioner_name})`,
          'practitioner_name': element.practitioner_name,
          'allDay': false,
          'appointment_id': element.appointment_id,
          'start': new Date(start),
          'end': new Date(end),  
        })
      })
   // console.log("calendarFormattedData", calendarFormattedData);

    if (!this.state.isScreenLoaded) {
      return (
        <div className="dashboard-loader">
          <img src={ttmLoader} alt="loader" className="loader-image" />
        </div>
      );
    }
    const appoinmentDetailsData = this.props.appointmentDetailsData && 
    this.props.appointmentDetailsData.appointmentDetails[0];
    
    return (
      <div>
        <div className={`row ${style.appointmentsMainWrapper}`}>
            <div className="col-md-12">
                <h3>Appointments Calendar</h3>
            </div>
            <div className="col-lg-12 intro-text">
                <p className="mb-4">
                {/* These are the general system wide settings. You can change as
                needed. */}
                </p>
            </div>
          </div>
           <div className="form-box-shadow">
            <div className="row">
              <div className="col-md-12">
                <BigCustomCalender 
                data={calendarFormattedData}
                onNavigate={this.handleOnNavigate}
                onEventSelect={this.onEventSelect} />
              </div>
            </div>
            </div>
             {/* Open a Appointment  view */}
          
        <Modal
            isOpen={this.state.isModalOpenAppointment}
            toggle={this.toggleAppointmentView}
            className="viewProductDetailsModal"
            centered
          >
            {this.state.isAppointmentModalLoading ? (
            <div className={style.loadingWrapper}>
              <img src={ttmLoader} alt="modal-loader" className={style.loading} />
            </div>
          ) : (
          <React.Fragment>
            <ModalHeader
              toggle={this.onEventSelect}
              className={style.deleteModalHeader}
            >
              Appointment Details
            </ModalHeader>
            <ModalBody>
              <div className={style.productviewDetailsWrapper}>
                <div className="row">
                  {/* <div className="col-md-12">
                    <h6 className={style.viewHeading}>Contact</h6>
                  </div> */}
                  <div className="col-md-3">
                    <p className="key">Appointment Type:</p>
                  </div>
                  <div className="col-md-3">
                    <p>
                      {appoinmentDetailsData &&
                        appoinmentDetailsData.lk_appointment_type}
                    </p>
                  </div>
                </div>
                <hr />
                <div className="row ">
                  <div className="col-md-12">
                    <h6 className={style.viewHeading}>Details</h6>
                  </div>
                  <div className="col-md-6">
                    <div className="row">
                      <div className="col-md-6">
                        <p className="key">Name of the Contact:</p>
                      </div>
                      <div className="col-md-6">
                        <p>
                          {appoinmentDetailsData && appoinmentDetailsData.name}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="row">
                      <div className="col-md-6">
                        <p className="key">Physical Address:</p>
                      </div>
                      <div className="col-md-6">
                        <p>
                          {appoinmentDetailsData &&
                          appoinmentDetailsData.physical_address
                            ? appoinmentDetailsData.physical_address
                            : "Not Provided"}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="row">
                      <div className="col-md-6">
                        <p className="key">Referrence Number:</p>
                      </div>
                      <div className="col-md-6">
                        <p>
                          {appoinmentDetailsData &&
                          appoinmentDetailsData.reference_id}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="row">
                      <div className="col-md-6">
                        <p className="key">Phone Number:</p>
                      </div>
                      <div className="col-md-6">
                        <p>
                          {appoinmentDetailsData &&
                          appoinmentDetailsData.contact_number
                            ? appoinmentDetailsData.contact_number
                            : "Not Provided"}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="row">
                      <div className="col-md-6">
                        <p className="key">Email:</p>
                      </div>
                      <div className="col-md-6">
                        <p>
                          {appoinmentDetailsData &&
                          appoinmentDetailsData.email
                            ? appoinmentDetailsData.email
                            : "Not Provided"}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="row">
                      <div className="col-md-6">
                        <p className="key">Authorization Number:</p>
                      </div>
                      <div className="col-md-6">
                        <p>
                          {appoinmentDetailsData &&
                          appoinmentDetailsData.authorization_number
                            ? appoinmentDetailsData.authorization_number
                            : "Not Provided"}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="row">
                      <div className="col-md-6">
                        <p className="key">Referring Practitioner:</p>
                      </div>
                      <div className="col-md-6">
                        <p>
                          {appoinmentDetailsData &&
                          appoinmentDetailsData.requested_related_party_id
                            ? this.getRequestedProfessional(appoinmentDetailsData.requested_related_party_id)
                            : "Not Provided"}
                        </p>
                      </div>
                    </div>
                  </div>
                  
                  
                  <div className="col-md-6">
                    <div className="row">
                      <div className="col-md-6">
                        <p className="key">Room:</p>
                      </div>
                      <div className="col-md-6">
                        <p>
                          {appoinmentDetailsData &&
                            this.getRoom(appoinmentDetailsData.room_id)}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="row">
                      <div className="col-md-6">
                        <p className="key">Appointment Reason:</p>
                      </div>
                      <div className="col-md-6">
                        <p>
                          {appoinmentDetailsData &&
                            this.getAppointmentReason(appoinmentDetailsData.lk_appointment_reason_id)}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="row">
                      <div className="col-md-6">
                        <p className="key">Appointment Status:</p>
                      </div>
                      <div className="col-md-6">
                        <p>
                          {appoinmentDetailsData &&
                            this.getAppointmentStatus(appoinmentDetailsData.lk_appointment_status_id)}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="row">
                      <div className="col-md-6">
                        <p className="key">Payment Type:</p>
                      </div>
                      <div className="col-md-6">
                        <p>
                          {appoinmentDetailsData &&
                            appoinmentDetailsData.lk_appointment_status_id == "1"?"Pre-Payment":"Post-Payment"}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="row">
                      <div className="col-md-6">
                        <p className="key">Notes:</p>
                      </div>
                      <div className="col-md-6">
                        <p>
                          {appoinmentDetailsData &&
                            appoinmentDetailsData.notes ?
                            appoinmentDetailsData.notes : "Not Available"}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <hr />

                {appoinmentDetailsData && appoinmentDetailsData.appointment_date && (
                <div className="row">
                  <div className="col-md-12">
                    <h6 className={style.viewHeading}>Appointment Date(s)</h6>
                  </div>
                  <div className="col-md-12">
                    <div className="row">
                      <div className="col-md-12">
                      {this.renderScheduledDates(appoinmentDetailsData.appointment_date)}
                      </div>
                    </div>
                  </div>
                </div>)}
                <hr />

                  {checkIfPermitted(Permissions.MANAGE_LETTERS) && (
                  <div className="row">
                    <div className="col-md-12">
                      <h6 className={style.viewHeading}>Attached Document(s)</h6>
                    </div>
                    <div className="col-md-12">
                      <div className="row mb-2">
                      <div className="col-md-12">
                          {appoinmentDetailsData && 
                          appoinmentDetailsData.conductAppointmentNotes && appoinmentDetailsData.conductAppointmentNotes.length > 0 &&
                          appoinmentDetailsData.conductAppointmentNotes.map((element, index) => (
                            
                                <span key={element.conductappointment_notes_id}
                                class={`${style.caseFileWrapper} mr-3`}
                                 onClick={(e) =>
                                      this.downloadFile(
                                        element.appointment_id,
                                        element.lk_document_type_id
                                      )
                                    }>
                                  <i
                                    className={`fa fa-paperclip mr-2 ${style.caseFileIcon}`}
                                  ></i>
                                  {/* <span>{element.lk_document_type_id === 1 ? "Doctor Note": element.lk_document_type_id === 2 : "Referral Note" : ""}</span> */}
                                  <span>
                                    {element.lk_document_type_id === 1
                                      ? "Doctor Note"
                                      : element.lk_document_type_id === 2
                                      ? "Referral Note"
                                      : "Prescription"}
                                  </span>
                                </span>
                            ))}
                          {(appoinmentDetailsData && ((appoinmentDetailsData.conductAppointmentNotes &&
                            appoinmentDetailsData.conductAppointmentNotes.length === 0)|| 
                            !appoinmentDetailsData.conductAppointmentNotes)) && (                            
                              <p>No attached documents found</p>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>)}

                <hr />
                
                {appoinmentDetailsData 
                && appoinmentDetailsData.isPatientFile && (
                <div className="row">
                  <div className="col-md-12">
                    <h6 className={style.viewHeading}>Patient File</h6>
                  </div>
                  <div className="col-md-6">
                    <div className="row">
                      <div className="col-md-12">
                      <span
                                class={style.caseFileWrapper}
                                onClick={()=>this.onDownloadSubmitFile(appoinmentDetailsData)}
                              >
                                <i
                                  class={`fa fa-paperclip mr-2 ${style.caseFileIcon}`}
                                ></i>
                                {appoinmentDetailsData && 
                                  appoinmentDetailsData.file_number && (
                                  <span> {`${appoinmentDetailsData && 
                                  appoinmentDetailsData.file_number}.pdf`} </span>)}

                                  {appoinmentDetailsData && 
                                  !appoinmentDetailsData.file_number && (
                                  <span> {`${appoinmentDetailsData && 
                                  appoinmentDetailsData.name}.pdf`} </span>)}
                              </span>
                      </div>
                    </div>
                  </div>
                </div>
                )}
                <div className="row">
                  <div className="col-md-12">
                    {this.state.isCaseFileDownloading  ? (
                      <div className={style.loadingWrapper}>
                        <img src={ttmLoader} alt="loader" className={style.loading} />
                      </div>
                    ) : (
                      <div>
                        {this.state.successMessage && (
                          <p className={style.successMessage}>
                            {this.state.successMessage}
                          </p>
                        )}
                        {this.state.errorMessage && (
                          <p className={style.errorMessage}>
                            {this.state.errorMessage}
                          </p>
                        )}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </ModalBody>
              </React.Fragment>
        )}
          </Modal>
      </div>
    );
  }
}

// export default Setting;

const mapStateToProps = (state) => {
  return {
    dropdownListData: state.dropdownList,
    calendarAppointmentsData: state.calendarAppointments,
    appointmentDetailsData: state.appointmentDetails,
    appointmentDropdownData: state.appointmentDropdown,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchAppointmentDetails: (appointment_id)=> dispatch(fetchAppointmentDetails(appointment_id)),
    fetchDropdownList: () => dispatch(fetchDropdownList()),
    fetchCalendarAppointments: (bdate) => dispatch(fetchCalendarAppointments(bdate)),
    fetchAppointmentDropdown: () => dispatch(fetchAppointmentDropdown()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AppointmentsCalendar);
